import { JobCenterModelInterface } from '../Model/JobCenterModelInterface';
import { SortableModelInterface } from '../Model/SortableModelInterface';

function removeDuplicates<T>(items: T[]): T[] {
    let unique: { [key: string]: T } = {};
    items.forEach(item => {
        let key = '';
        if (typeof item === 'string' || typeof item === 'number') {
            key = '' + item;
        } else if (typeof item === 'object' && typeof (item as any)['referenceId'] !== 'undefined') {
            key = '' + (item as any)['referenceId'];
        }

        if (typeof unique[key] === 'undefined') {
            unique[key] = item;
        }
    });
    return Object.values(unique);
}

function valueForKeyPath<T extends JobCenterModelInterface>(instance: T, keyPath: string): any {
    if (keyPath.indexOf('.') === -1) {
        return (instance as any)[keyPath];
    }
    const keyParts = keyPath.split('.');

    return keyParts.reduce((carry, key) => {
        if (carry !== null && typeof carry === 'object') {
            return (carry as any)[key];
        } else {
            return undefined;
        }
    }, instance);
}

export class FilterOptions {
    public static collectOptions<T extends JobCenterModelInterface, R>(models: T[], keyPath: string): R[] {
        const values = models.map(i => valueForKeyPath(i, keyPath)).filter(i => !!i);

        return removeDuplicates(values).sort(
            (
                a: Partial<SortableModelInterface>,
                b: Partial<SortableModelInterface>
            ) => {
                if (a.sorting === undefined && b.sorting === undefined) {
                    return 0;
                }
                if (a.sorting === undefined) {
                    return -1;
                }
                if (b.sorting === undefined) {
                    return 1;
                }

                if (a.sorting < b.sorting) {
                    return -1;
                } else if (a.sorting > b.sorting) {
                    return 1;
                } else {
                    return 0;
                }
            }
        );
    }
}
